const PENtoUSD = amount =>  amount *  0.26;

export default PENtoUSD;

